import React, { useEffect } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"
import { logoutUser } from "../../store/actions"
import axios from "axios"

//redux
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import apiURl from "url"

const Logout = () => {
  const history = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const performLogout = async () => {
      const userId = localStorage.getItem("authUser")

      // Dispatch Redux logout action
      dispatch(logoutUser(history))
    }

    performLogout()
  }, [dispatch, history])

  return null
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
